import { CardItemIcon, CardSubtitle, CardTitle } from '@/components/Card'
import {
  ExpandableCardListItem,
  ExpandableCardListItemContent,
} from '@/components/ExpandableCardList'
import {
  Skeleton,
  SkeletonList,
  useSkeletonListContext,
} from '@/components/Skeleton'

interface SkeletonAccordionListProps {
  count: number
}

export function SkeletonAccordionList({ count }: SkeletonAccordionListProps) {
  return (
    <SkeletonList count={count}>
      <SkeletonAccordionItem />
    </SkeletonList>
  )
}

function SkeletonAccordionItem() {
  const { varyPercent } = useSkeletonListContext()

  return (
    <ExpandableCardListItem isSkeleton textValue="Loading">
      <ExpandableCardListItemContent
        isSkeleton
        icon={<CardItemIcon skeleton name="square-user-round" />}
        align="center"
      >
        <CardTitle>
          <Skeleton width={varyPercent(20)} />
        </CardTitle>
        <CardSubtitle variant="sm">
          <Skeleton width={varyPercent(15)} />
        </CardSubtitle>
      </ExpandableCardListItemContent>
    </ExpandableCardListItem>
  )
}
